import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { RouteComponentProps, StaticContext, withRouter } from 'react-router';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps extends RouteComponentProps<{ id: string }, StaticContext, undefined> {
  title: string;
  path: string;
  callback?: () => void;
  isBeta?: boolean;
  isLoading?: boolean;
  noTranslation?: boolean;
  className?: string;
  titleClassName?: string;
}

const HeaderBack: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const onBack = () => {
    if (props.callback) {
      props.callback();
      return;
    }

    props.history.push(props.path);
  };

  const titleName = useMemo((): string => {
    return props.noTranslation ? props.title : localeStore.t(props.title);
  }, [props.title, props.noTranslation]);

  return (
    <div className={classNames('header-back', props.className)} onClick={onBack}>
      <Icon name={Icons.Back} size={26} color={theme.colors.mainblue} className="header-back__icon mr-4" />
      <h1 className="header-back__title text-elipsis">
        {!appStore.timestamp || !localeStore.localizationLoaded || props.isLoading ? <Skeleton width={300} height={39} /> : titleName}
      </h1>
    </div>
  );
});

export default withRouter(HeaderBack);
